import { render, staticRenderFns } from "./OutroList.vue?vue&type=template&id=c854cae0&"
import script from "./OutroList.vue?vue&type=script&lang=js&"
export * from "./OutroList.vue?vue&type=script&lang=js&"
import style0 from "./OutroList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports